import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

export const INBOX_API_KEY = 'InboxAccess';

export const getInboxAccessKeys = ({ projectId }) => [INBOX_API_KEY, projectId];

const url = `${PREFIX_URL}/v01/InboxAccess`;

type GetInboxAccessResponse = any;

const getInboxAccess = ({ projectId }): Promise<GetInboxAccessResponse> => {
  const baseUrl = generateRoutePath(url, null, { projectId });
  return axios.get(baseUrl);
};

type QueryFnType = typeof getInboxAccess;

type UseGetInboxAccessParams = {
  projectId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetInboxAccess = ({ projectId, config }: UseGetInboxAccessParams) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: getInboxAccessKeys({ projectId }),
    queryFn: () => getInboxAccess({ projectId }),
    staleTime: Infinity,
    ...config,
  });
};
